import { useContext } from 'react';
import WordlistContext from './_contexts/WordlistContext';

export default function WordlistLanguageSelector() {
  const { wordlist, switched, switchLanguages } = useContext(WordlistContext);

  if (!wordlist) return <div className="wordlist__language-selector bc-shimmer" />;

  const {
    sourceLanguage: { name: source },
    targetLanguage: { name: target },
  } = wordlist;

  return (
    <div className="wordlist__language-selector" data-testid="wordlist__language-selector">
      <span className="language-selector__language">{!switched ? source : target}</span>
      <button className="language-selector__button" onClick={switchLanguages} disabled={!wordlist.canSwitchLanguage}>
        <svg className="icon icon-switch" role="img">
          <use href="#icon-switch" />
        </svg>
      </button>
      <span className="language-selector__language">{!switched ? target : source}</span>
    </div>
  );
}
